import { lazy, Suspense } from "react";
const Workspace = lazy(() => import("./ImagingWorkspace"));
export default function ImagingModule(props) {
  return (
    <Suspense
      fallback={
        <div role="status" style={{ padding: 30, color: "#6c829e" }}>
          Preparando Imagenología…
        </div>
      }
    >
      <Workspace {...props} />
    </Suspense>
  );
}
